import React from 'react';
import Webcam from 'react-webcam';

function CamTest(props) {
  return <Webcam mirrored audio={false} width='100%' height='100%' />;
}

export default CamTest;
